import React from 'react';
import { createUniqueKey, getClassNames, transformOptions } from '../../../utils';
import { TOptionsList } from '../../../types';
import Loader from '../../Loader';

type OptionListProps = {
    name: string,
    options: TOptionsList | null,
    clicked: (val?: any) => void,
    selected: string,
    searchInProgress?: boolean;
};

function OptionList({
    name = 'option', options = null, clicked = () => {}, selected, searchInProgress = false,
} : OptionListProps) {
    if (searchInProgress) {
        return <Loader/>;
    }

    return transformOptions(options)?.map(({
        label, value, disabled
    }, index) => {
        const className = getClassNames('select__option',
            { 'select__option-active': selected === value },
            { 'select__option-disabled': disabled });

        return (
            <div
                id={`${name}-${index}`}
                className={className}
                aria-selected={selected === value ? true : undefined}
                role="option"
                tabIndex={0}
                key={createUniqueKey(index, label)}
                onClick={() => !disabled && clicked(value)}
                onKeyDown={() => !disabled && clicked(value)}
            >
                <div className="checkbox-wrapper">{label}</div>
            </div>
        );
    });
}

export default OptionList;
